import * as React from 'react';
import { Spin, Card, Space, List } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';
import { ScriptUsageResult } from '../../types';

type Props = {
    scriptUsages: ScriptUsageResult[];
    isLoadingUsages: boolean;
};

const SqlScriptUsages: React.FC<Props> = ({ scriptUsages, isLoadingUsages }) => {
    return (
        <div style={{ marginBottom: 24 }}>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>Used In</div>
            <Spin spinning={isLoadingUsages} size="small">
                {scriptUsages.length > 0 ? (
                    <Card size="small">
                        <List
                            dataSource={scriptUsages}
                            renderItem={(usage: ScriptUsageResult) => (
                                <List.Item style={{ padding: '8px 0', borderBottom: 'none' }}>
                                    <Space>
                                        <AppstoreOutlined style={{ color: '#1890ff' }} />
                                        <a
                                            target="_blank"
                                            rel="noreferrer"
                                            href={`/projects/${usage.projectId}/applicationDefinitions?highlightAppId=${
                                                usage.applicationDefinitionId
                                            }`}
                                        >
                                            {usage.applicationDefinitionName}
                                        </a>
                                    </Space>
                                </List.Item>
                            )}
                        />
                    </Card>
                ) : (
                    <Card size="small">
                        <div style={{ color: '#8c8c8c', fontStyle: 'italic' }}>
                            This script is not currently used by any applications.
                        </div>
                    </Card>
                )}
            </Spin>
        </div>
    );
};

export default SqlScriptUsages;
